import { useState, useEffect } from 'react';

import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

import logoAppleBox from 'assets/applebox/Logo_Applebox.png'
import fontAppleBox from 'assets/applebox/Font_Applebox.png'
import iconAvatar from 'assets/applebox/Icon_Avatar.png'
import imgBalanceBox from 'assets/applebox/AppBarBalanceBox.png'

import useAuth from 'hooks/useAuth';
import { jwtDecode } from 'jwt-decode';

const Header = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { user } = useAuth();
    const [userIcon, setUserIcon] = useState();

    const { drawerOpen } = useSelector((state) => state.menu);
    const matchDown400 = useMediaQuery(theme.breakpoints.down('400'));

    const onClickLogin = () => {
        navigate("/login");
    }

    const onClickRegister = () => {
        navigate("/register");
    }

    useEffect(() => {
        if(user != null) setUserIcon(user.picture);
    }, [user]);

    return (
        <Box position="sticky" top={0} sx={{ zIndex: 99, width: '100%', background: '#1a1d2e', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <Box sx={{ m: '0 auto', maxWidth: '500px' }}>
                <Box sx={{ p: '15px 10px 17px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 0.5 }}>
                        <Box component={'img'} src={logoAppleBox} alt="menu" width={46} onClick={() => dispatch(openDrawer(!drawerOpen))} />
                        {
                            user == null &&
                            // <Box component={'img'} src={fontAppleBox} alt="logo" width={120} />
                            <Typography fontSize={matchDown400 ? '15px': '20px'} fontWeight={700} textAlign={'start'} color={'#fff'}>APPLEBOX</Typography>
                        }
                    </Box>
                    {
                        user != null &&
                        <Box sx={{ width:matchDown400 ? '150px' : '200px', height:matchDown400 ? '42px' : '57px', backgroundImage: `url(${imgBalanceBox})`, backgroundSize: 'cover', display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <Typography fontSize={matchDown400 ? '13px': '15px'} fontWeight={400} textAlign={'center'} color={'#fff'} display={'inline'}>{Math.floor(user.balance).toLocaleString()}</Typography>
                            <Typography ml={1} fontSize={matchDown400 ? '13px': '15px'} fontWeight={700} textAlign={'center'} color={'#fff'} display={'inline'}>XABT</Typography>
                            <Box sx={{width:'15%'}} />
                        </Box>
                    }
                    {
                        user != null &&
                            <Box>
                                <Box sx={{ m: '0 auto', width: '40px' }}>
                                    <Box component={'img'} src={userIcon ? userIcon : iconAvatar} referrerPolicy="no-referrer" alt="logo" sx={{ width: '36px', borderRadius: '20px' }} />
                                </Box>
                                <Typography fontSize={matchDown400 ? '10px' : '12px'} fontWeight={700} textAlign={'center'} color={'#757575'}>{user.appleboxid}</Typography>
                            </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
};

export default Header;
